module.exports = "/_next/static/images/dreamland-9ecb5008857f6f1c635292423ca7fbf7.png";